import { useLocation, Outlet } from "react-router-dom";
import {
  Database, Upload, Search, FileBarChart, Activity
} from "lucide-react";
import HubSidebar from "@/components/HubSidebar";


import TopNav from "@/components/TopNav"
import HubSwitcher from "@/components/HubSwitcher";
const NAV_ITEMS = [
  {
    id: "ingest",
    label: "Ingest Data",
    icon: Upload,
    path: "/ims/ingest",
    description: "SOCMINT, IMINT, HUMINT, SIGINT, Cyber, Geospatial"
  },
  {
    id: "facts",
    label: "Facts Browser",
    icon: Search,
    path: "/ims/facts",
    description: "Query normalised intelligence facts"
  },
  {
    id: "reports",
    label: "Reports",
    icon: FileBarChart,
    path: "/ims/reports",
    description: "Generate threat briefs & profiles"
  },
  {
    id: "raw",
    label: "Raw Data",
    icon: Activity,
    path: "/ims/raw",
    description: "Browse ingested raw records"
  }
];

export default function ImsHubLayout() {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <>
    <TopNav />
    <div className="min-h-screen bg-app flex flex-col md:flex-row">
      <HubSidebar
        navItems={NAV_ITEMS}
        title="IMS HUB"
        subtitle="Intelligence Management"
        icon={Database}
        gradient="from-emerald-500 to-teal-500"
        activeBg="bg-emerald-500"
      />

      <main className="flex-1 overflow-auto flex">
        <div className="flex-1 min-w-0 p-4">
          <Outlet />
        </div>
        <div className="hidden lg:block w-40 shrink-0 p-3 border-l border-app">
          <HubSwitcher />
        </div>
      </main>
    </div>
    </>
  );
}
